//电站显示配置
export const GET_VISIBLE_PS='home/devicetypelist/GET_VISIBLE_PS';

export const SET_VISIBLE_PS='home/devicetypelist/SET_VISIBLE_PS';

export const SET_VISIBLE_TYPE='home/devicetypelist/SET_VISIBLE_TYPE';



